var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 1H3.5C2.12305 1 1 2.12305 1 3.49961V14.7145C1 16.0914 2.12305 17.1793 3.5 17.1793H7.83984L10.4656 20.6805C10.625 20.918 10.8125 21 11 21C11.1875 21 11.375 20.9167 11.5 20.75L14.1258 17.2488H18.5C19.877 17.2488 21 16.1258 21 14.784V3.49961C21 2.12305 19.8789 1 18.5 1ZM19.75 14.7148C19.75 15.4039 19.1891 15.9297 18.5 15.9297H13.5352L11 19.332L8.49883 15.9973H3.5C2.81094 15.9973 2.25 15.4367 2.25 14.7824V3.49961C2.25 2.81055 2.81094 2.25 3.5 2.25H18.5C19.1891 2.25 19.75 2.81055 19.75 3.49961V14.7148Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.a51e833a8909dc958f9867ccfa5bea2c.svg";
export { ForwardRef as ReactComponent };